import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  FbpReportRequestInput,
  GetFlexibleBenefitReportResponse,
  GetFlexibleBenefitReportVariables,
} from '../types';

const getFlexibleBenefitReportQuery = gql`
  query PayrollGetFBPReport($input: FbpReportRequestInput!) {
    payrollGetFBPReport(input: $input) {
      code
      success
      message
      total_count
      employee_reports {
        user_id
        employee_email
        employee_name
        employee_id
        components {
          component_name
          is_applicable
          max_limit_month
          amount_declared_month
          amount_declared_annual
          amount_accrued_till_date
          amount_claimed_till_date
          amount_approved_till_date
          amount_processed_month
          amount_processed_till_date
          amount_pending_disbursal
        }
      }
    }
  }
`;

export const getFlexibleBenefitReport = (input: FbpReportRequestInput) => {
  return graphQLApi<GetFlexibleBenefitReportResponse, GetFlexibleBenefitReportVariables>({
    query: getFlexibleBenefitReportQuery,
    queryVariables: { input },
  });
};
